import styled from 'styled-components';
import { spacing, font, breakpoints } from '@chegg-ui/theme';
import { Button, SecondaryButton } from '@chegg-ui/button';
export var FactorSelectionSC = styled.div.withConfig({
  componentId: "sc-9tbwbv-0"
})(["display:flex;flex-direction:column;justify-content:center;align-items:center;"]);
export var PrimaryButtonSC = styled(Button).withConfig({
  componentId: "sc-9tbwbv-1"
})(["margin:", " auto ", " auto;padding:", ";font-size:", ";width:318px;@media only screen and (max-width:", "){width:216px;}"], spacing.px16, spacing.px24, spacing.px8, font.size.px20, breakpoints.sm.max);
export var SecondaryButtonSC = styled(SecondaryButton).withConfig({
  componentId: "sc-9tbwbv-2"
})(["margin-bottom:", ";padding:", ";font-size:", ";width:318px;@media only screen and (max-width:", "){width:216px;}"], function (_ref) {
  var isMobile = _ref.isMobile;
  return isMobile ? spacing.px16 : spacing.px24;
}, spacing.px8, font.size.px20, breakpoints.sm.max);